//@TODO - Clean up the Cookies code below to be more functionally performant
const { CookieJar } = require("tough-cookie");
const util = require("util");
const tintworldCookie = async () => {
  const cookieJar = new CookieJar();
  const setCookie = util.promisify(cookieJar.setCookie.bind(cookieJar));
  await setCookie("foo=bar", "http://10.1.10.50");
  //got.get('http://10.1.10.50',{cookieJar});
};

export const setAllCoupons = (state, data) => {
  state.coupons.allCoupons = data;
};

export const setStageNumber = (state, data) => {
  if (data >= 0) state.components.form.stageNumber = data;
  else state.components.form.stageNumber = 0;
};

export const setCouponData = (state, data) => {
  state.coupons.couponData = data;
};
export const setSelectedCoupon = (state, data) => {
  state.coupons.selectedCoupon = data;
};
export const setCategories = (state, data) => {
  // console.log('setCategories', data)
  state.categories = data;
};
export const setProducts = (state, data) => {
  // console.log('setProducts', data)
  state.products = data;
};
export const setGclid = (state, data) => {
  state.user.gclid = data;
}
export const setGclidNull = (state) => {
  state.user.gclid = null;
}
export const setDeals = (state, data) => {
  state.deals = data;
};
export const setAbouts = (state, data) => {
  state.abouts = data;
};
export const setCarYears = (state, data) => {
  state.carYears = data;
};
export const setRegions = (state, data) => {
  state.regions = data;
};
export const setVehicles = (state, data) => {
  // var cookiejar = new tough.CookieJar();
  if (data) {
    //var CookieJar = require('tough-cookie');
    // console.log("save data ", JSON.stringify(data))
    localStorage.setItem("my_vehicles", JSON.stringify(data));
    //CookieJar.setCookie(newCookie('test','value'),'http://10.1.10.50/', cookieError);
    tintworldCookie();
    var future = new Date();
    future.setDate(future.getDate() + 30);
    document.cookie = "test=value;expires=" + future;
  } else {
    // console.log("vehicle empty")
    localStorage.removeItem("my_vehicles");
  }
  state.myVehicles = data;
};
export const setPpcStore = (state, data) => {
  state.user.ppc_store = data;
};
export const setPpcCampaign = (state, data) => {
  state.user.campaign = data;
};
export const resetResponse = (state) => {
  state.form_response.responseCode = null;
  state.form_response.responseDetails = null;
  state.form_response.responseErrors = null;
  state.form_response.responseMessage = null;
  state.form_response.responseHeadline = null;
  state.form_response.transactionID = null;
  state.critical_form_error = false;
};
export const resetUserForm = (state, data) => {
  state.user.services = [];
  state.coupons.selectedCoupon = null;
  state.affiliate.complete = false;
  state.user.ppc_service = null;
  state.user.ppc_store = null;
  state.user.selectedResultIndex = null;
  state.form_response.responseCode = null;
  state.form_response.responseDetails = null;
  state.form_response.responseErrors = null;
  state.form_response.responseMessage = null;
  state.form_response.responseHeadline = null;
  state.form_response.transactionID = null;
  state.critical_form_error = false;
  state.user.notes = null;
  state.user.residential_type = null;
  state.user.commercial_type = null;
  state.user.marine_type = null;
  state.user.selectedStoreForInquiry = null;
  state.user.requested_appointment = null;
  state.user.requested_appointment_date = null;
  state.user.requested_appointment_time = null;
  state.components.appointment.availability = [];
  state.components.appointment.steps.forEach(function (step) {
    step.complete = false;
    if (step.id == 1) {
      step.active = true;
    } else {
      step.active = false;
    }
  });
  state.components.quote.steps.forEach(function (step) {
    step.complete = false;
    if (step.id == 1) {
      step.active = true;
    } else {
      step.active = false;
    }
  });
  state.components.appointment.errors = null;
  state.components.quote.errors = null;
  if (data.type == "appointment") {
    state.components.appointment.current_step = 1;
    state.components.appointment.complete = false;
  }
  if (data.type == "quote") {
    state.components.quote.current_step = 1;
    state.components.quote.complete = false;
    state.components.form.stageNumber = 0;
  }
};

export const setAffiliateComplete = (state, data) => {
  state.affiliate.complete = data;
};
export const setAffiliateErrors = (state, data) => {
  state.affiliate.errors = data;
};
export const processErrors = (state, data) => {
  let type = data.formType;
  if (type == "quote") {
    state.components.quote.errors = data.errors;
  }
  if (type == "appointment") {
    state.components.appointment.errors = data.errors;
  }
  if (type == "ppc") {
    if (state.user.ppc_form_type == "quote") {
      state.components.quote.errors = data.errors;
    }
    if (state.user.ppc_form_type == "appointment") {
      state.components.appointment.errors = data.errors;
    }
  }
};
export const setUserID = (state, data) => {
  if (data) {
    state.user.leadId = data;
  }
};
export const cancelOffsite = (state) => {
  state.user.off_site = false;
};
export const resetServices = (state) => {
  state.user.services = [];
};
export const fullResetUser = (state) => {
  //@TODO - For any nested object can use Object.keys(state.user.address).forEach(function(key){state.user.address[key]=null});
  state.user.userSearchLocation = null;
  state.user.storeResults = [];
  state.coupons.selectedCoupon = null;
  state.user.selectedStoreForInquiry = null;
  state.user.first_name = null;
  state.user.last_name = null;
  state.user.selectedResultIndex == null;
  state.user.email = null;
  state.user.phone = null;
  state.user.service_category = null; //should just track via ID
  state.user.services = []; //just going to track via ID
  state.user.service_object_type = null; //deprecate
  state.user.products = [];
  state.user.page_url = null;
  state.user.requested_appointment = null;
  state.user.notes = null;
  state.user.vehicle.year = null;
  state.user.vehicle.make = null;
  state.user.vehicle.model = null;
  state.user.vehicle.doors = null;
  state.user.marine_type = null;
  state.user.commercial_type = null;
  state.user.residential_type = null;
  state.user.off_site = false;

  state.user.address.street = null;
  state.user.address.street_2 = null;
  state.user.address.city = null;
  state.user.address.region = null;
  state.user.address.postal_code = null;
};
export const setFormProcessing = (state, data) => {
  state.form_processing = data;
};
export const setFirstName = (state, data) => {
  state.user.first_name = data;
};
export const setUserFieldNull = (state, data) => {
  state.user[data] = null;
};
export const setUser = (state, data) => {
  if (data.first_name) {
    state.user.first_name = data.first_name;
  }
  if (data.last_name) {
    state.user.last_name = data.last_name;
  }
  if (data.email) {
    state.user.email = data.email;
  }
  if (data.phone) {
    state.user.phone = data.phone;
  }
  if (data.year) {
    state.user.vehicle.year = data.year;
  }
  if (data.make) {
    state.user.vehicle.make = data.make;
  }
  if (data.model) {
    state.user.vehicle.model = data.model;
  }
  if (data.doors) {
    state.user.vehicle.doors = data.doors;
  }
  if (data.marine_type) {
    state.user.marine_type = data.marine_type;
  }
  if (data.residential_type) {
    state.user.residential_type = data.residential_type;
  }
  if (data.commercial_type) {
    state.user.commercial_type = data.commercial_type;
  }
  if (data.requested_appointment) {
    state.user.requested_appointment = data.requested_appointment;
  }
  if (data.store) {
    state.user.store = data.store;
  }
  if (data.services) {
    state.user.services = data.services;
  }
  if (data.products) {
    state.user.products = data.products;
  }
  if (data.page_url) {
    state.user.page_url = data.page_url;
  }
  if (data.off_site) {
    state.user.off_site = data.off_site;
  }
  if (data.street) {
    state.user.address.street = data.street;
  }
  if (data.street_2) {
    state.user.address.street_2 = data.street_2;
  }
  if (data.city) {
    state.user.address.city = data.city;
  }
  if (data.region) {
    state.user.address.region = data.region;
  }
  if (data.postal_code) {
    state.user.address.postal_code = data.postal_code;
  }
  if (data.notes) {
    state.user.notes = data.notes;
  }
  if (data.service_object_type) {
    state.user.service_object_type = data.service_object_type;
  }
};
export const completeAppointment = (state, data) => {
  console.log(data);
  console.log(state);
};
export const setAppointmentStatus = (state, data) => {
  if (data.current_step) {
    state.appointment.current_step = data.current_step;
  }
};
export const setUserCurrentPage = (state) => {
  //'//' + location.host + location.pathname
  state.user.page_url =
    "https://" + window.location.host + window.location.pathname;
};
export const setResponse = (state, data) => {
  if (data.responseCode) {
    state.form_response.responseCode = data.responseCode;
  }
  if (data.responseErrors) {
    state.form_response.responseErrors = data.responseErrors;
  }
  if (data.responseHeadline) {
    state.form_response.responseHeadline = data.responseHeadline;
  }
  if (data.responseMessage) {
    state.form_response.responseMessage = data.responseMessage;
  }
  if (data.responseDetails) {
    state.form_response.responseDetails = data.responseDetails;
  }
  if (data.transactionID) {
    state.form_response.transactionID = data.transactionID;
  }
};
export const resetAppointment = (state) => {
  state.user.requested_appointment_date = null;
  state.user.requested_appointment_time = null;
  state.components.appointment.availability = [];
};
export const appointmentValidationFailed = (state, data) => {
  state.components.appointment.validation_failed = data;
};
export const updateUserSearchResults = (state, data) => {
  if (data) {
    state.user.search_results = data.search_results;
  }
};
export const updateUserSearchLocation = (state, data) => {
  if (data) {
    state.user.user_location.lat = data.lat;
    state.user.user_location.lng = data.lng;
    state.user.user_location.city = data.city;
    state.user.user_location.region = data.region;
  }
};
export const setOffSite = (state, data) => {
  state.user.off_site = data;
};
export const setStoreByIndex = (state, index) => {
  //state.myStore = data;
  state.user.selectedResultIndex = index;
  state.myStore = state.user.search_results[state.user.selectedResultIndex];
};
export const setFormStore = (state, store) => {
  state.user.selectedStoreForInquiry = store;
};
export const setStore = (state, data) => {
  if (data) {
    // console.log("save store data ", JSON.stringify(data))
    localStorage.setItem("my_store", JSON.stringify(data));
    var future = new Date();
    future.setDate(future.getDate() + 30);
    var encString = data["location-id"];
    document.cookie =
      "userTwStore=" + encString + "; expires=" + future + "; path=/";
  } else {
    // console.log("store empty")
    localStorage.removeItem("my_store");
  }
  state.myStore = data;
};
export const setCarMakes = (state, data) => {
  state.user.vehicle.make = null;
  state.user.vehicle.model = null;
  state.carMakes = data;
};
export const resetUserVehicleModel = (state) => {
  state.user.vehicle.model = null;
};
export const togglePpcFormState = (state, data) => {
  state.user.ppc_form_type = data;
};
export const setInitialAvailability = (state, data) => {
  state.components.appointment.availability = data;
};
export const setAvailabilityQuery = (state) => {
  state.components.appointment.availability_queried = new Date();
};
export const addAvailabilityDates = (state, data) => {
  state.components.appointment.availability = [].concat(
    state.components.appointment.availability,
    data
  );
};
export const updateActiveAvailabilityIndex = (state, data) => {
  //vm.availability[foundIndex].active = true;
  state.components.appointment.availability = data;
};
export const toggleFormCriticalError = (state, data) => {
  //vm.availability[foundIndex].active = true;
  state.critical_form_error = data;
};
export const userSelectedAppointmentDate = (state, data) => {
  state.user.requested_appointment_date = data;
};
export const userSelectedAppointmentTime = (state, data) => {
  state.user.requested_appointment_time = data;
};
export const setFormLocation = (state, data) => {
  // Will set as 'Place'
  state.user.selectedStoreForInquiry = data;
};
export const setUserAutoLocation = (state, data) => {
  // Will set as 'Place'
  state.user.user_location.lat = data.lat;
  state.user.user_location.lng = data.lng;
  state.user.user_location.city = data.city;
  state.user.user_location.region = data.region;
};
export const selectStoreFromResults = (state, index) => {
  state.user.selectedResultIndex = index;
  state.user.selectedStoreForInquiry = state.user.search_results[index];
};
export const setPrimaryVehicle = (state, data) => {
  // Will set as vehicle/props = year,make,model,doors
  state.primaryVehicle = data;
};
export const setFormServices = (state, data) => {
  // Will set as vehicle/props = year,make,model,doors
  state.form_service_options = data;
};
export const setUserServiceCategory = (state, data) => {
  // Will set as vehicle/props = year,make,model,doors
  state.user.service_category = data;
};
export const setInitialPPCAvailability = (state, data) => {
  console.log(data);
  state.ppc_disabled_dates = data.disabled_dates;
  state.ppc_disabled_to = data.disabled_to;
  state.ppc_disabled_from = data.disabled_from;
};
export const updatePPCAvailability = (state, data) => {
  //@TODO - Use the mutation to handle the date comparisons
  let previous_date = new Date(state.ppc_disabled_from);
  let query_date = new Date(data.disabled_from);
  if (previous_date < query_date) {
    state.ppc_disabled_from = data.disabled_from;
    state.ppc_disabled_dates = [].concat(
      state.ppc_disabled_dates,
      data.disabled_dates
    );
  }
};
export const setUserServices = (state, data) => {
  // Will set as vehicle/props = year,make,model,doors
  state.user.services = data;
};
export const setCurrentPageStorePromotion = (state, data) => {
  state.page_promotion.name = data.promotion.name;
  state.page_promotion.alias = data.promotion.alias;
  state.page_promotion.start = data.promotion.start;
  state.page_promotion.expiration = data.promotion.expiration;
  if (data.promotion.banner !== null) {
    state.page_promotion.banner = data.promotion.banner.file_url;
  }
  if (data.store !== undefined) {
    state.page_promotion.store_id = data.store.id;
  }
  if (data.coupons !== undefined) {
    if (data.coupons.length > 0) {
      state.page_promotion.store_coupons = data.coupons;
    }
  }
};
export const setCurrentPagePromotion = (state, data) => {
  state.page_promotion.name = data.name;
  state.page_promotion.alias = data.alias;
  state.page_promotion.start = data.promotion_start;
  state.page_promotion.expiration = data.promotion_expiration;
  if (data.banner !== null) {
    state.page_promotion.banner = data.banner.file_url;
  }
};
export const resetCurrentPageStoreCoupons = (state) => {
  state.page_promotion.store_coupons = [];
};
export const setCurrentPromotion = (state, data) => {
  state.current_promotion.name = data.promotion.name;
  state.current_promotion.alias = data.promotion.alias;
  state.current_promotion.start = data.promotion.promotion_start;
  state.current_promotion.expiration = data.promotion.promotion_expiration;
  if (data.promotion.banner !== null) {
    state.current_promotion.banner = data.promotion.banner.file_url;
  }
  if (data.store !== undefined) {
    state.current_promotion.store_id = data.store.id;
  }
  if (data.coupons !== undefined) {
    if (data.coupons.length > 0) {
      state.current_promotion.store_coupons = data.coupons;
    }
  }
};
export const resetCurrentPromotionCoupons = (state) => {
  state.current_promotion.store_coupons = [];
};
export const setCartItems = (state, data) => {
  state.cart.items = data;
};
export const setCartData = (state, data) => {
  state.cart.data = data;
};
export const setTotalPrice = (state, data) => {
  state.cart.totalPrice = data;
};
export const setStorePromos = (state, data) => {
  state.promotion.name = data.promotion.name;
  state.promotion.alias = data.promotion.alias;
  state.promotion.promotion_start = data.promotion.promotion_start;
  state.promotion.promotion_expiration = data.promotion.promotion_expiration;
  state.promotion.promotion_url = data.promotion.landing_page;
  state.promotion.store_id = data.store.id;
  state.promotion.coupons = data.coupons;
  if (data.promotion.banner !== null) {
    state.promotion.banner = data.promotion.banner.file_url;
  }
};
export const resetStorePromos = (state) => {
  state.promotion.name = null;
  state.promotion.alias = null;
  state.promotion.promotion_start = null;
  state.promotion.promotion_expiration = null;
  state.promotion.coupons = [];
  state.promotion.store_id = null;
  state.promotion.banner = null;
};
export const resetFormStore = (state) => {
  state.user.selectedResultIndex = null;
  state.user.selectedStoreForInquiry = null;
};
export const setUserPPCServices = (state, data) => {
  // Will set as vehicle/props = year,make,model,doors
  state.user.ppc_service = data;
};

/* appointment */
export const setApptModels = (state, data) => {
  state.appt_options_marine = data["marine-options"];
  state.appt_options_residential = data["residential-options"];
  state.appt_options_commercial = data["commercial-options"];
};
export const setLeadAppointment = (state, data) => {
  state.user.requested_appointment = data;
};
export const setAppointment = (state, { data, type }) => {
  if (type === "store") {
    state.appointment.store = data.store;
    state.user.selectedStoreForInquiry = data.store;
  }
  if (type === "service") {
    state.appointment.service = data;
  }
  if (type === "datetime") {
    state.appointment.datetime = data;
    state.user.requested_appointment = data;
  }
  if (type === "contact") {
    console.log(data);
    state.appointment.contact = data;
    setUser(state, data);
  }
  if (type === "confirm") {
    state.appointment.confirm = data;
  }
  if (type === "init")
    state.appointment = {
      store: null,
      service: null,
      datetime: null,
      contact: null,
    };
  // console.log("set my appointment")
  localStorage.setItem("my_appointment", JSON.stringify(state.appointment));
};
export const setMyAppointment = (state, data) => {
  // console.log(data)
  if (data.datetime) {
    // 2020-10-23T15:46:55.773Z
    var str_date = data.datetime.date.date;
    // console.log("datetime", data.datetime.date.date)
    var milisec = Date.parse(str_date);
    // console.log("milisec", milisec)
    data.datetime.date.date = new Date(milisec);
  }
  state.appointment = data;
};
export const setUserAppointment = (state, data) => {
  // console.log(data)
  if (data.datetime) {
    // 2020-10-23T15:46:55.773Z
    var str_date = data.datetime.date.date;
    // console.log("datetime", data.datetime.date.date)
    var milisec = Date.parse(str_date);
    // console.log("milisec", milisec)
    data.datetime.date.date = new Date(milisec);
  }
  state.appointment = data;
};
export const update_appointment = (state, type) => {
  //@TODO - Is this method better than my method currently?
  // appt_store | appt_service | appt_date | appt_contact | appt_confirm | appt_book
  const list_appt_states = [
    "appt_store",
    "appt_service",
    "appt_date",
    "appt_contact",
    "appt_confirm",
    "appt_book",
  ];
  var index = list_appt_states.findIndex((l) => l === state.appt_cur_stage);
  if (type === "next") {
    index++;
  } else {
    index--;
    if (index < 0) index = 0;
  }
  state.appt_cur_stage = list_appt_states[index];
};
export const edit_appointment = (state, stage) => {
  state.appt_cur_stage = stage;
};
/* quote */
export const setQuoteModels = (state, data) => {
  state.appt_options_marine = data["marine-options"];
  state.appt_options_residential = data["residential-options"];
  state.appt_options_commercial = data["commercial-options"];
};
export const setQuote = (state, { data, type }) => {
  if (type === "store") state.quote.store = data;
  if (type === "service") state.quote.service = data;
  if (type === "contact") state.quote.contact = data;
  if (type === "confirm") state.quote.confirm = data;
  if (type === "init")
    state.quote = {
      store: null,
      service: null,
      contact: null,
    };

  localStorage.setItem("my_quote", JSON.stringify(state.quote));
};
export const setMyQuote = (state, data) => {
  state.quote = data;
};
export const update_quote = (state, type) => {
  const list_quote_states = [
    "quote_store",
    "quote_service",
    "quote_contact",
    "quote_confirm",
    "quote_book",
  ];
  var index = list_quote_states.findIndex((l) => l === state.quote_cur_stage);
  if (type === "next") {
    index++;
  } else {
    index--;
    if (index < 0) index = 0;
  }
  state.quote_cur_stage = list_quote_states[index];
};
export const edit_quote = (state, stage) => {
  state.quote_cur_stage = stage;
};
export const mobileSidebarToggle = (state) => {
  state.mobileMenuOpen1 = false;
  state.selectedMenu1 = "";
  state.mobileMenuOpen2 = false;
  state.selectedMenu2 = "";
  state.menu2Items = [];
  state.menu3Items = [];
  state.currentItem = [];
};
export const desktopDropdownToggle = () => {};
export const desktopMenuOpen = (state, menu_label) => {
  state.mobileMenuOpen1 = !state.mobileMenuOpen1;
  state.selectedMenu1 = menu_label;
  switch (menu_label) {
    case "services":
      state.currentItem = { url: "/services/" };
      state.menu2Items = state.categories;
      break;
    case "products":
      state.currentItem = { url: "/store/" };
      state.menu2Items = state.products;
      break;
    case "deals":
      state.currentItem = { url: "/promotions/" };
      state.menu2Items = state.deals;
      break;
    case "abouts":
      state.currentItem = { url: "/about-us/" };
      state.menu2Items = state.abouts;
      break;
    case "help":
      state.currentItem = { url: "/help-center/" };
      state.menu2Items[1] = state.abouts[1];
      break;
    case "resources":
      state.currentItem = { url: "/resources/" };
      state.menu2Items = state.abouts[2];
      break;
    case "news":
      state.currentItem = { url: "/news-media/" };
      state.menu2Items = state.abouts[3];
      break;
  }
};
export const singleTierOpen = (state, menu_label) => {
  state.mobileMenuOpen1 = !state.mobileMenuOpen1;
  switch (menu_label) {
    case "abouts":
      state.menu2Items = state.abouts;
      break;
    case "help":
      state.selectedMenu1 = "Help Center";
      state.mobileMenuOpen1 = true;
      state.menu2Items = state.abouts[1].children;
      break;
    case "resources":
      state.selectedMenu1 = "Resources";
      state.mobileMenuOpen1 = true;
      state.menu2Items = state.abouts[2].children;
      break;
    case "news":
      state.selectedMenu1 = "News & media";
      state.mobileMenuOpen1 = true;
      state.menu2Items = state.abouts[3].children;
      break;
  }
};
export const TOGGLE_MODAL = (state, type) => {
  if (type === "appointment") {
    // console.log("cur modal state " + state.appointment_modal)
    state.appointment_modal = !state.appointment_modal;
  } else if (type === "quote") {
    state.quote_modal = !state.quote_modal;
  }
};
export const ToggleModal = (state, type) => {
  state.components.modalActive = !state.components.modalActive;
  if (type === "appointment") {
    // console.log("cur modal state " + state.appointment_modal)
    state.components.appointment.active = !state.components.appointment.active;
  } else if (type === "quote") {
    state.components.quote.active = !state.components.quote.active;
  }
};
export const OpenModal = (state, type) => {
  state.components.modalActive = true;
  // Foreach components, and set each one to active = false, then set the correct one?
  if (type === "appointment") {
    if (state.components.quote.active) {
      state.components.quote.active = false;
    }
    state.components.checkout.active = false;
    state.components.appointment.active = true;
  } else if (type === "quote") {
    if (state.components.appointment.active) {
      state.components.appointment.active = false;
    }
    state.components.checkout.active = false;
    state.components.quote.active = true;
  } else if (type === "checkout") {
    state.components.quote.active = false;
    state.components.appointment.active = false;
    state.components.checkout.active = true;
  }
};
export const CloseModal = (state, type) => {
  state.components.modalActive = false;
  if (type === "appointment") {
    // console.log("cur modal state " + state.appointment_modal)
    state.components.appointment.active = false;
  } else if (type === "quote") {
    state.components.quote.active = false;
  }
};
export const CloseAllModals = (state) => {
  state.components.modalActive = false;
  if (state.components.appointment.active) {
    state.components.appointment.active = false;
  }
  if (state.components.quote.active) {
    state.components.quote.active = false;
  }
};
export const FormStepBack = (state, form) => {
  //@TODO - Let's add functions to handle the situation where there is no 'active state' for the component steps, and we need to reset one by default

  //@TODO - Can we add functions?
  //@TODO - Let's add deeper step by step logic... we can account for going steps beyond what the user has completed, and this should assist with validation issues
  if (form.type == "appointment") {
    //var current_step = state.components.appointment.steps.filter(item => item.active == true);
    //var previous_step = state.components.appointment.steps.findIndex(item => item.id == current_step[0].id-1);
    var current_step = state.components.appointment.steps.findIndex(
      (item) => item.active == true
    );
    var total_steps = state.components.appointment.steps.length;

    if (current_step == -1) {
      state.components.appointment.steps[0].active = true;
      state.components.appointment.current_step = 0;
      return;
    }
    if (form.change == "increment" && current_step <= total_steps) {
      console.log(state.components.appointment.steps);

      state.components.appointment.steps[current_step].active = false;
      state.components.appointment.steps[current_step].complete = true;
      state.components.appointment.steps[current_step + 1].active = true;
      state.components.appointment.current_step = current_step + 1;
      return;
    }

    if (form.change == "reduce" && current_step > 0) {
      state.components.appointment.steps[current_step].active = false;
      state.components.appointment.steps[current_step - 1].active = true;
      state.components.appointment.current_step = current_step - 1;
      return;
    }
    if (form.change == "go_to") {
      state.components.appointment.steps[current_step].active = false;
      state.components.appointment.steps[form.go_to].active = true;
      state.components.appointment.current_step = form.go_to;
      return;
    }
  }
};
export const FormStepBackCheckout = (state, form) => {
  //@TODO - Let's add functions to handle the situation where there is no 'active state' for the component steps, and we need to reset one by default

  //@TODO - Can we add functions?
  //@TODO - Let's add deeper step by step logic... we can account for going steps beyond what the user has completed, and this should assist with validation issues
  if (form.type == "checkout") {
    //var current_step = state.components.appointment.steps.filter(item => item.active == true);
    //var previous_step = state.components.appointment.steps.findIndex(item => item.id == current_step[0].id-1);
    var current_step = state.components.checkout.steps.findIndex(
      (item) => item.active == true
    );
    var total_steps = state.components.checkout.steps.length;

    if (current_step == -1) {
      state.components.checkout.steps[0].active = true;
      state.components.checkout.current_step = 0;
      return;
    }
    if (form.change == "increment" && current_step <= total_steps) {
      state.components.checkout.steps[current_step].active = false;
      state.components.checkout.steps[current_step].complete = true;
      state.components.checkout.steps[current_step + 1].active = true;
      state.components.checkout.current_step = current_step + 1;
      return;
    }

    if (form.change == "reduce" && current_step > 0) {
      state.components.checkout.steps[current_step].active = false;
      state.components.checkout.steps[current_step - 1].active = true;
      state.components.checkout.current_step = current_step - 1;
      return;
    }
    if (form.change == "go_to") {
      //console.log(form.go_to);
      state.components.checkout.steps[current_step].active = false;
      state.components.checkout.steps[form.go_to].active = true;
      state.components.checkout.current_step = form.go_to;
      return;
    }
  }
};

export const QuoteFormBack = (state, form) => {
  //console.log(form, "quoteformback");
  if (form.type == "quote") {
    var current_step = state.components.quote.steps.findIndex(
      (item) => item.active == true
    );
    var total_steps = state.components.quote.steps.length;
    if (current_step == -1) {
      state.components.quote.steps[0].active = true;
      state.components.quote.current_step = 0;
    }
    if (form.change == "increment" && current_step <= total_steps) {
      state.components.quote.steps[current_step].active = false;
      state.components.quote.steps[current_step].complete = true;
      state.components.quote.steps[current_step + 1].active = true;
      state.components.quote.current_step = current_step + 1;
    }
    if (form.change == "reduce" && current_step > 0) {
      state.components.quote.steps[current_step].active = false;
      state.components.quote.steps[current_step - 1].active = true;
      state.components.quote.current_step = current_step - 1;
    }
    if (form.change == "go_to") {
      state.components.quote.steps[current_step].active = false;
      state.components.quote.steps[form.go_to].active = true;
      state.components.quote.current_step = form.go_to;
    }
  }
};
export const MOBILE_TOGGLE_MENU2 = (state, sel_id) => {
  if (sel_id !== -1) {
    const active_item = state.menu2Items[sel_id];
    state.currentItem = active_item;
    if (active_item.children !== undefined) {
      state.mobileMenuOpen2 = !state.mobileMenuOpen2;
      state.selectedMenu2 = active_item.title ? active_item.title : "";
      state.menu3Items = active_item.children ? active_item.children : [];
      state.selectedMenuAlias = active_item.alias ? active_item.alias : "";
    } else {
      // state.gotoLink(active_item.url)
      location.href = active_item.url;
      return;
    }
  } else {
    if (state.mobileMenuOpen1) {
      switch (state.selectedMenu1) {
        case "services":
          state.currentItem = { url: "/services/" };
          break;
        case "products":
          state.currentItem = { url: "/store/" };
          break;
        case "deals":
          state.currentItem = { url: "/promotions/" };
          break;
        case "abouts":
          state.currentItem = { url: "/about-us/" };
          break;
        case "about":
          state.currentItem = { url: "/about-us/" };
          break;
        case "help":
          state.currentItem = { url: "/help-center/" };
          break;
        case "resources":
          state.currentItem = { url: "/resources/" };
          break;
        case "news":
          state.currentItem = { url: "/news-media/" };
          break;
      }
    } else {
      state.currentItem = {};
    }
    state.mobileMenuOpen2 = !state.mobileMenuOpen2;
    state.selectedMenu2 = "";
    state.menu3Items = [];
  }
};
